// @flow
export class CampaignNotFoundError extends Error {
    constructor (message) {
        super(message)
        this.name = 'CampaignNotFoundError'
    }
}
